import {
  GET_SALESWARRANTY,
  GET_SALESWARRANTY_SUCCESS,
  GET_SALESWARRANTY_FAIL,
  DELETE_SALESWARRANTY,
  DELETE_SALESWARRANTY_SUCCESS,
  DELETE_SALESWARRANTY_FAIL,
  UPDATE_SALESWARRANTY,
  UPDATE_SALESWARRANTY_SUCCESS,
  UPDATE_SALESWARRANTY_FAIL,
  ADD_NEW_SALESWARRANTY,
  ADD_SALESWARRANTY_SUCCESS,
  ADD_SALESWARRANTY_FAIL,
  SALESWARRANTY_LOADING,
  SALESWARRANTY_RESET,
} from "./actionType";

export const resetSalesWarrantyState = (actionType) => ({
  type: SALESWARRANTY_RESET,
  payload: { actionType },
});

export const getSalesWarrantySuccess = (actionType, data) => ({
  type: GET_SALESWARRANTY_SUCCESS,
  payload: { actionType, data },
});

export const getSalesWarrantyFail = (actionType, error) => ({
  type: GET_SALESWARRANTY_FAIL,
  payload: { actionType, error },
});

export const getSalesWarranty = data => ({
  type: GET_SALESWARRANTY,
  payload: data,
});

export const getSalesWarrantyLoading = () => ({
  type: SALESWARRANTY_LOADING
});

export const deleteSalesWarranty = data => ({
  type: DELETE_SALESWARRANTY,
  payload: data,
});

export const deleteSalesWarrantySuccess = data => ({
  type: DELETE_SALESWARRANTY_SUCCESS,
  payload: data,
});

export const deleteSalesWarrantyFail = error => ({
  type: DELETE_SALESWARRANTY_FAIL,
  payload: error,
});

export const updateSalesWarranty = data => ({
  type: UPDATE_SALESWARRANTY,
  payload: data,
});

export const updateSalesWarrantyFail = error => ({
  type: UPDATE_SALESWARRANTY_FAIL,
  payload: error,
});

export const updateSalesWarrantySuccess = data => ({
  type: UPDATE_SALESWARRANTY_SUCCESS,
  payload: data,
});

export const addNewSalesWarranty = data => ({
  type: ADD_NEW_SALESWARRANTY,
  payload: data,
});

export const addSalesWarrantySuccess = data => ({
  type: ADD_SALESWARRANTY_SUCCESS,
  payload: data,
});

export const addSalesWarrantyFail = error => ({
  type: ADD_SALESWARRANTY_FAIL,
  payload: error,
});